var render = function render(){var _vm=this,_c=_vm._self._c;return _c('at-breadcrumb',[_c('at-breadcrumb-item',[_vm._v(" Главная ")]),_vm._l((_vm.getList),function(item,id){return _c('at-breadcrumb-item',{key:id,attrs:{"href":`#/${item.type}/${item.id}`}},[_vm._v(" "+_vm._s(item.name)+" ")])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }